import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { useSiteSettings } from '../services/siteSettingsService';

const LegalNotice = () => {
  const { settings } = useSiteSettings();

  return (
    <>
      <Helmet>
        <title>Mentions Légales - {settings.brandFullName}</title>
        <meta
          name="description"
          content={`Mentions légales et informations juridiques de ${settings.brandFullName}`}
        />
      </Helmet>

      <main className="min-h-screen py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="bg-white rounded-2xl shadow-xl p-8"
          >
            <h1 className="text-3xl font-bold mb-8">Mentions Légales</h1>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">1. Informations légales</h2>
              <p className="mb-4">
                {settings.brandFullName} est une marque exploitée par {settings.legalCompanyName},
                entreprise basée en {settings.legalCountry}.
              </p>
              <ul className="space-y-2">
                <li><strong>Entreprise :</strong> {settings.legalCompanyName}</li>
                <li><strong>Nom commercial :</strong> {settings.legalRepresentative}</li>
                <li><strong>Numéro d’identification :</strong> {settings.legalRegistrationId}</li>
                <li><strong>Siège social :</strong> {settings.legalAddress}</li>
                <li><strong>Email :</strong> {settings.contactEmail}</li>
                <li><strong>Téléphone :</strong> {settings.phoneDisplay}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">2. Hébergement</h2>
              <p>
                Ce site est hébergé par {settings.hostingProviderName}.<br />
                {settings.hostingProviderAddress}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">3. Propriété intellectuelle</h2>
              <p className="mb-4">
                L'ensemble de ce site relève de la législation suisse et internationale sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">4. Protection des données personnelles</h2>
              <p className="mb-4">
                Conformément à la Loi fédérale sur la protection des données (LPD), vous disposez d’un droit d’accès, de rectification et de suppression concernant vos données personnelles. Vous pouvez exercer ce droit en nous contactant par email.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-4">5. Cookies</h2>
              <p>
                Ce site utilise des cookies pour améliorer l'expérience utilisateur. En continuant à naviguer sur ce site, vous acceptez leur utilisation.
              </p>
            </section>
          </motion.div>
        </div>
      </main>
    </>
  );
};

export default LegalNotice;
